<template>
    <div class="ccpay-security">
        <div class="ccpay-security-header">
                <span @click="back"> 退後</span>
                <span v-if="type=='googole'">解绑谷歌验证码</span>
                <span v-if="type=='password'">更改密码</span>
                <span></span>
         </div>
         <div class="ccpay-security-connect">
             <form action="" v-if="type=='password'">
                   <mt-field  placeholder="请输入六位验证码"  style="border-bottom: 1px solid #ccc;"    :attr="{ 'maxlength': 6 }" type="tel"
                        class='captchaInput' v-model="code">
                        <span ref='spn' @click="getPhoneGetCaptcha()"  class="captcha">获取验证码</span>
                    </mt-field>
                    <mt-field class="passInputWord" style="border-bottom: 1px solid #ccc;"   placeholder="旧密码" type="password" v-model="oldpassword"
                    > </mt-field>
                    <mt-field class="passInputWord" style="border-bottom: 1px solid #ccc;"   placeholder="新密码" type="password" v-model="newpassword"
                    > </mt-field>

                    <mt-button class="mt-40" size="large" type="primary" @click.prevent="emit" 
                        style='letterSpacing:5px;padding-right:0.2rem' >更改</mt-button>
                </form>
                <form action="" v-else>
                    <mt-field   placeholder="请输入谷歌验证码"  style="border-bottom: 1px solid #ccc;" 
                            class='captchaInput' v-model="code">
                    </mt-field>
                     <mt-button class="mt-40" size="large" type="primary" @click.prevent="changecode" 
                        style='letterSpacing:5px;padding-right:0.2rem' >解绑</mt-button>
                 </form>
         </div>
    </div>
</template>

<script>
import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers,captchaDownTime} from '../../public/index.js'
import { Indicator } from 'mint-ui';
export default {
    data(){
        return {
            userinfo:{},
            type:'',
            phone:'',
            code:'',
            oldpassword:'',
            newpassword:''
        }
    },
    mounted(){
        this.type = this.$route.query.type
    },
    methods:{
         back(){
            this.$router.go(-1)
        },
        changecode(){
            
                if(this.code==''){
                 this.$Toast('请输入谷歌验证码')
                 return
                 }
                 Indicator.open();
                let obj ={ 
                     "validata": {
                        "googleCode": this.code
                    }
                }
                this.$axios.post('/v1/security/google/unbind',obj).then(res=>{
                    Indicator.close();
                    this.$Toast(res.msg)
                    this.back()
                })
          

        },
        vercode(){
            // this.$axios.post('/v1/verify/phone_code',{
            //    "code":this.code
            // }).then(res=>{
            //     console.log(res.data.result)
            // })
        },
        emit(){
                 
                 if(this.code==''){
                    this.$Toast('请输入验证码')
                    return
                 }
                 if(this.oldpassword==''){
                    this.$Toast('请输入旧密码')
                    return
                 }
                 if(this.newpassword==''){
                    this.$Toast('请输入新密码')
                    return
                 }
                 Indicator.open();
                let obj = {
                    "data":{
                        "oldpassword":this.oldpassword,
                        "newpassword":this.newpassword
                    },
                    "validata":{
                        "emailCode":this.code
                    }
                }
                this.$axios.post('/v1/account/update_password',obj).then(res=>{
                    Indicator.close();
                    if(res.code==0){
                        this.back()
                         this.$Toast('更改成功')
                         this.oldpassword = ''
                         this.newpassword = ''
                         this.code = ''
                    }else{
                         this.$Toast('更改失败')
                    }
                })
        },
        //获取手机验证码
        getPhoneGetCaptcha(){
            if(this.$refs.spn.innerHTML=='获取验证码'){
                this.$axios.get('/v1/verify/send_mail_code').then(res=>{
                    if(res.code==0){
                         this.$Toast('发送成功')
                    }else{
                         this.$Toast('发送失败')
                    }
                })
                captchaDownTime(this.$refs.spn)
             }
        }
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-security{
         height: 100%;;
         background: white;
        .ccpay-security-header{
              background: white;
                display: flex;
                justify-content: space-between;
                padding: 1rem;
        }
        .ccpay-security-connect{
            padding: 1rem;
            padding-right: 2rem;
            background: white;
            ul li{
                position: relative;
                padding: 1.125rem 0rem;
                color: #666;
                font-size: 0.93rem;
                border-bottom: 1px solid;
                border-color: #eee;
                span{
                    float: right;
                }
                a{
                    color: #666;
                }
            }
        }
    }
    .captcha{
        padding: 0.5rem 0.9375rem;
        background: #26a2ff;
        border-radius: 3.4375rem;
        font-size: 0.875rem;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/my/changeCode.vue